import {
  AccountBalanceOutlined,
  AutoAwesomeMotionOutlined,
  AutoModeOutlined,
  BusinessOutlined,
  DashboardOutlined,
  FileDownloadOutlined,
  FileUploadOutlined,
  LinkOutlined,
  PaidOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import CommodityTokenSvg from "../components/Svg/CommodityTokenSvg";
import InvestmentPoolSvg from "../components/Svg/InvestmentPoolSvg";
import { Roles } from "../types";

export interface MenuItem {
  label: string;
  link: string;
  renderIcon: () => any;
  role?: Roles | Roles[];
}

export const Menu: MenuItem[][] = [
  [
    {
      label: "Dashboard",
      link: "/",
      renderIcon: () => <DashboardOutlined />,
    },
    {
      label: "Companies",
      link: "/companies",
      renderIcon: () => <BusinessOutlined />,
    },
    {
      label: "Payments",
      link: "/payments",
      renderIcon: () => <PaidOutlined />,
    },
    {
      label: "Offers",
      link: "/offers",
      renderIcon: () => <FileUploadOutlined />,
    },
    {
      label: "Requests",
      link: "/requests",
      renderIcon: () => <FileDownloadOutlined />,
    },
  ],
  [
    {
      label: "Plans",
      link: "/plans",
      renderIcon: () => <AutoAwesomeMotionOutlined />,
    },
  ],
  [
    {
      label: "Smart Deals",
      link: "/smart-deals",
      renderIcon: () => <LinkOutlined />,
      role: Roles.BlockchainAdmin,
    },
    {
      label: "Commodity Tokens",
      link: "/commodity-tokens",
      renderIcon: () => <CommodityTokenSvg />,
      role: Roles.BlockchainAdmin,
    },
    {
      label: "Investment Pools",
      link: "/investment-pools",
      renderIcon: () => <InvestmentPoolSvg />,
      role: [Roles.BlockchainAdmin, Roles.TreasuryAdmin],
    },
    {
      label: "Treasury Management",
      link: "/treasury-management",
      renderIcon: () => <AccountBalanceOutlined />,
      role: Roles.TreasuryAdmin,
    },
  ],
  [
    {
      label: "Schedules",
      link: "/schedules",
      renderIcon: () => <AutoModeOutlined />,
    },
  ],
];

export const SettingsMenu = {
  label: "Settings",
  link: "/settings",
  renderIcon: () => <SettingsOutlined />,
};
